module.exports = __webpack_public_path__ + "static/media/screen.9aa8b030.png";